import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Grid, Typography } from '@mui/material';
import { SummaryTable } from './summaryTable.smart';
import { ClearedToPlay } from './clearedToPlay/clearToPlay';
import { di } from '../../../../state/inversify.config';
import { AssessmentCreationViewService } from '../assessmentCreationView/assessmentCreation.view.service';
import { Banner } from '../../../../components/banner/banner';

export function SummaryPage() {
  const assessmentCreationViewService: AssessmentCreationViewService =
    di.get<AssessmentCreationViewService>(AssessmentCreationViewService);
  const modules = assessmentCreationViewService.useModuleSelector();
  const { t } = useTranslation();

  const isNew = modules === undefined || Object.keys(modules).length === 0;

  return (
    <Container>
      <Typography variant="h6">{t('assessment.ASSESSMENT_SUMMARY')}</Typography>
      {isNew ? (
        <Banner severity="warning" elevation={2} title={t('GENERIC_ERROR')} />
      ) : (
        <Grid sx={{ mb: 2 }}>
          <SummaryTable modules={modules} />
          <ClearedToPlay />
        </Grid>
      )}
    </Container>
  );
}
